<template>
  <div id="survey-privilege" class="text-black">
    <b-form>
      <b-card no-body class="p-2 px-5 container-card mb-1 font-medium-5">
        <b-row>
          <b-col>
            <div>ผลลัพธ์สิทธิ์ใช้งาน</div>
            <div>
              สมาชิกที่กำหนดเท่านั้น
              <span class="text-black font-weight-bolder">
                ที่ได้สิทธิ์ใช้งานแบบสำรวจนี้ได้</span
              >
              <!-- <img
                src="~@/assets/images/icons/IconQuestion.png"
                alt=""
                class="ml-2"
                width="15"
              /> -->
            </div>
            <div class="card-premission-wrp mt-2 d-flex">
              <div class="w-100">
                <b-badge
                  class="change-permission"
                  v-for="(item, index) in privilegeData.permissionListSetting"
                  :key="index"
                  >{{ item.tagName }}</b-badge
                >
              </div>

              <div
                class="d-flex justify-content-end align-item-center h-100 w-10 font-medium-3"
              >
                <div
                  :class="!privilegeData.isEdit ? 'bypass' : ''"
                  class="text-change font-medium-4"
                  @click="onOpenModalChangePermission"
                >
                  Change
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card no-body class="p-2 px-5 container-card mb-1 font-medium-5">
        <b-row>
          <b-col>
            <div>ประเภทการให้รางวัล</div>
            <div class="ml-5 mt-2">
              <b-form-radio-group
                class="text-black custom-radio-group mr-5 font-medium-3"
                v-model="privilegeData.rewardType"
                :options="changeOption.optionRewardtype"
                value-field="item"
                text-field="name"
                :disabled="!privilegeData.isEdit"
                :class="!privilegeData.isEdit ? 'bypass' : ''"
              ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card
        no-body
        class="p-2 px-5 container-card mb-1 font-medium-5"
        v-if="privilegeData.rewardType != 0"
      >
        <b-row>
          <b-col>
            <div>กำหนดเงื่อนไขการให้แต้มของสมาชิก</div>
            <div class="ml-5 mt-2 d-flex">
              <b-form-radio
                v-model="privilegeData.isEqual"
                name="condition-point"
                value="1"
                :disabled="!privilegeData.isEdit"
                :class="!privilegeData.isEdit ? 'bypass' : ''"
                class="text-black custom-radio-group type-reward mr-3 font-medium-3"
                >สมาชิกได้<span class="text-underline font-weight-bolder">{{
                  privilegeData.rewardType == PRIVILEGETYPE.REWARDTYPE.POINT
                    ? "แต้มเท่ากัน"
                    : "รางวัลเท่ากัน"
                }}</span></b-form-radio
              >
              <b-form-radio
                v-model="privilegeData.isEqual"
                name="condition-point"
                value="2"
                :disabled="
                  privilegeData.permissionListSetting == 0 ||
                  !privilegeData.isEdit
                "
                :class="!privilegeData.isEdit ? 'bypass' : ''"
                class="text-black custom-radio-group type-reward mr-3 font-medium-3"
                >สมาชิกได้<span class="text-underline font-weight-bolder">{{
                  privilegeData.rewardType == PRIVILEGETYPE.REWARDTYPE.POINT
                    ? "แต้มไม่เท่ากัน"
                    : "รางวัลไม่เท่ากัน"
                }}</span></b-form-radio
              >
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card
        no-body
        class="p-2 px-5 container-card mb-1 font-medium-5"
        v-if="privilegeData.rewardType != PRIVILEGETYPE.REWARDTYPE.NOREWRAD"
      >
        <b-row>
          <b-col>
            <div>กำหนดการให้แต้ม</div>
            <div class="ml-5 mt-2">
              <b-row>
                <b-col cols="12">
                  <div class="font-weight-bolder">
                    ตอบครบทุกข้อ
                    {{
                      privilegeData.rewardType == PRIVILEGETYPE.REWARDTYPE.POINT
                        ? "เพื่อรับแต้ม"
                        : "เพื่อรับของรางวัล"
                    }}
                  </div>
                  <div class="d-flex justify-content-between">
                    <div>
                      {{
                        privilegeData.rewardType ==
                        PRIVILEGETYPE.REWARDTYPE.POINT
                          ? " ผู้ตอบแบบสำรวจจะต้องตอบคำถามให้ครบข้อ เพื่อได้รับแต้ม"
                          : "ผู้ตอบแบบสำรวจจะต้องตอบคำถามให้ครบข้อ เพื่อได้รับของรางวัล"
                      }}
                    </div>
                    <div
                      v-if="
                        privilegeData.rewardType ==
                          PRIVILEGETYPE.REWARDTYPE.POINT &&
                        privilegeData.isEqual == PRIVILEGETYPE.EQUALTYPE.EQUAL
                      "
                    >
                      <input-spin-quiz
                        :isDisabled="!privilegeData.isEdit"
                        :numValue="privilegeData.point"
                        :isInputDisabled="false"
                        @update-number="onUpdatePoint"
                      />
                    </div>
                    <div
                      v-if="
                        privilegeData.rewardType ==
                          PRIVILEGETYPE.REWARDTYPE.POINT &&
                        privilegeData.isEqual ==
                          PRIVILEGETYPE.EQUALTYPE.NOTEQUAL
                      "
                      :class="!privilegeData.isEdit ? 'bypass' : ''"
                    >
                      <set-point-button
                        :btnLabel="
                          privilegeData.rewardType ==
                          PRIVILEGETYPE.REWARDTYPE.POINT
                            ? privilegeData.permissionListSetting.length > 0 &&
                              privilegeData.permissionListSetting[0].point
                              ? 'แก้ไขแต้ม'
                              : 'กำหนดแต้ม'
                            : ''
                        "
                        @click.native="onOpenModalSettingPoint"
                        :isDisabled="false"
                      />
                    </div>
                    <div
                      v-if="
                        privilegeData.rewardType ==
                          PRIVILEGETYPE.REWARDTYPE.REWARD &&
                        privilegeData.isEqual ==
                          PRIVILEGETYPE.EQUALTYPE.NOTEQUAL
                      "
                    >
                      <set-point-button
                        :btnLabel="
                          privilegeData.rewardType ==
                          PRIVILEGETYPE.REWARDTYPE.REWARD
                            ? privilegeData.permissionListSetting.length > 0 &&
                              privilegeData.permissionListSetting[0].reward
                              ? 'แก้ไขของรางวัล'
                              : 'กำหนดของรางวัล'
                            : ''
                        "
                        @click.native="onOpenModalSettingPoint"
                        :isDisabled="false"
                        :setIcon="
                          privilegeData.rewardType ==
                          PRIVILEGETYPE.REWARDTYPE.REWARD
                        "
                      />
                    </div>
                  </div>
                  <b-row
                    v-if="
                      privilegeData.rewardType ==
                        PRIVILEGETYPE.REWARDTYPE.REWARD &&
                      privilegeData.isEqual == PRIVILEGETYPE.EQUALTYPE.EQUAL
                    "
                    class="mt-1"
                  >
                    <b-col>
                      <label
                        for="select-inventory"
                        class="font-medium-4 text-black"
                      >
                        <span> Choose Inventory </span>
                      </label>
                      <v-select
                        v-model="privilegeData.selectInventory"
                        class="font-medium-5 v-select-filter bg-dropdown p-0 w-100"
                        :clearable="false"
                        placeholder="Master Inventory"
                        :options="optionData.inventoryList"
                        :reduce="(option) => option.value"
                        @input="
                          fetchPrivilegeList(
                            privilegeData.selectInventory,
                            true
                          )
                        "
                        @option:selected="onChangeInventory()"
                      />
                    </b-col>
                    <b-col>
                      <label
                        for="select-privilege"
                        class="font-medium-3 text-black"
                      >
                        <span> Privilege </span>
                      </label>
                      <v-select
                        v-model="privilegeData.selectPrivilegeData"
                        class="font-medium-5 v-select-filter bg-dropdown p-0 w-100"
                        :clearable="false"
                        :searchable="true"
                        placeholder="Select Privilege"
                        :options="optionData.privilegeList"
                        :reduce="(option) => option.value"
                        @option:selected="
                          onChangePrivilegeData(
                            privilegeData.selectPrivilegeData
                          )
                        "
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
            <div>
              <b-row>
                <b-col
                  cols="12"
                  v-if="
                    privilegeData.isEqual == PRIVILEGETYPE.EQUALTYPE.NOTEQUAL &&
                    privilegeData.permissionList.length > 0
                  "
                >
                  <div
                    class="setting-tag-wrp d-flex flex-wrap align-content-start"
                  >
                    <div
                      v-for="(item, index) in privilegeData.permissionList"
                      :key="index"
                      class="mr-3 mb-1"
                    >
                      <div
                        class="badge-tag-wrp"
                        v-if="
                          privilegeData.rewardType ==
                            PRIVILEGETYPE.REWARDTYPE.POINT &&
                          privilegeData.permissionList.length > 0 &&
                          item.point
                        "
                      >
                        <div class="badge-tag">
                          {{ item.tagName }},{{ item.point }}
                        </div>
                      </div>
                      <div
                        class="badge-tag-wrp"
                        v-if="
                          privilegeData.rewardType ==
                            PRIVILEGETYPE.REWARDTYPE.REWARD &&
                          privilegeData.permissionList.length > 0 &&
                          item.selectPrivilege
                        "
                      >
                        <div class="badge-tag">
                          {{ item.tagName }},{{ item.selectPrivilegeName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-form>
    <change-permission-modal
      v-if="modalType.isChangePermission"
      :modalData="privilegeData"
      :tagOption="tagOption"
      @onSelectTagVisibility="onSelectTagVisibility"
      @onInputDuplicateTag="onInputDuplicateTag"
      @onChangePermission="onChangePermission"
      @onCloseModal="onCloseModalChangePermission"
    />
    <setting-point-modal
      v-if="modalType.isSetPoint"
      :modalData="privilegeData"
      :optionData="optionData"
      :TYPE="PRIVILEGETYPE"
      @onSubmitSettingPoint="onSubmitSettingPoint"
      @onUpdatePoint="onUpdateSettingPoint"
      @onCloseModal="onCloseModalSettingPoint"
      @fetchPrivilegeList="fetchPrivilegeList"
      @onChangePrivilege="onChangePrivilege"
      @onChangeInventory="onChangeInventory"
    />
  </div>
</template>

<script>
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";
import usePrivilegeTab from "../hooks/usePrivilegeTab";
import SetPointButton from "@/views/components/button/SetPointButton.vue";
import vSelect from "vue-select";
import SettingPointModal from "./settingPrivilegeModal.vue";
import ChangePermissionModal from "./PermissionChangeModal.vue";

export default {
  props: {
    isEdit: { type: Boolean, default: false },
  },
  components: {
    vSelect,
    InputSpinQuiz,
    SetPointButton,
    SettingPointModal,
    ChangePermissionModal,
  },
  setup(props) {
    const {
      privilegeData,
      changeOption,
      modalType,
      onOpenModalSettingPoint,
      onCloseModalSettingPoint,
      onOpenModalChangePermission,
      onCloseModalChangePermission,
      tagOption,
      onUpdatePoint,
      optionData,
      onSelectTagVisibility,
      onChangePermission,
      onInputDuplicateTag,
      onSubmitSettingPoint,
      onUpdateSettingPoint,
      fetchPrivilegeList,
      fetchInventoryList,
      onChangePrivilege,
      onChangePrivilegeData,
      onChangeInventory,
      PRIVILEGETYPE,
    } = usePrivilegeTab(props);

    return {
      privilegeData,
      changeOption,
      modalType,
      onOpenModalSettingPoint,
      onCloseModalSettingPoint,
      onOpenModalChangePermission,
      onCloseModalChangePermission,
      tagOption,
      onUpdatePoint,
      optionData,
      onSelectTagVisibility,
      onChangePermission,
      onInputDuplicateTag,
      onSubmitSettingPoint,
      onUpdateSettingPoint,
      fetchPrivilegeList,
      fetchInventoryList,
      onChangePrivilege,
      onChangePrivilegeData,
      onChangeInventory,
      PRIVILEGETYPE,
    };
  },
};
</script>

<style>
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/pages/survey/privilege.css";
</style>